import React, { useMemo } from "react";
import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Paper,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { inputStyles } from "../styles/styles";
import BaseWindow from "./public/BaseWindow";
import { getNextStep } from "../utils/enums.ts";
import BaseTextField from "./public/BaseTextField";
import { connect } from "react-redux";
import NotFoundPage from "./public/NotFoundPage";
import { getErrorMessage, getPreviousStep } from "../utils/enums";
import { addProcessContext } from "../store/processContext/actions";

import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { updateAlert } from "../store/alert/actions";

function Kvkk(props) {
  const classes = inputStyles();
  const pageName = "kvkk";
  let history = useHistory();
  let { uuid } = useParams();

  const [value, setValue] = React.useState(null);
  const [numPages, setNumPages] = React.useState(1);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const devamClick = () => {
    if (value) {
      const nextStepName = getNextStep(pageName);
      props.dispatch(
        addProcessContext({ kvkkFlag: value, stepName: nextStepName })
      );
      history.push(nextStepName);
    } else {
      props.dispatch(
        updateAlert({
          severity: "error",
          text: "Onay seçimi zorunludur. Seçiminizi yaptıktan sonra devam ediniz.",
          open: true,
        })
      );
    }
  };

  const geriClick = () => {
    const prevStepName = getPreviousStep(pageName);
    props.dispatch(addProcessContext({ stepName: prevStepName }));
    history.push(prevStepName);
  };

  /*const url = useMemo((url) => {
    return {
      url: `${window.ENV.DOCUMENT_BASE_URL}${props.processContext.kvkkDocument}/${uuid}`,
    };
  });

  const KvkkDoc = React.memo(({ list }) => {
    return (
      <Document
        file={props.processContext.kvkkDocument}
        renderMode={"svg"}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.apply(null, Array(numPages))
          .map((x, i) => i + 1)
          .map((page) => (
            <Page key={page} pageNumber={page} />
          ))}
      </Document>
    );
  });
*/
  return props.processContext.stepName !== pageName ? (
    <NotFoundPage />
  ) : (
    <BaseWindow isBasket={true}>
      <Grid item xs={12}>
        <p className={classes.p}>
          Kişisel Verilerinizin Korunması Kanunu Kapsamında Açık Rıza Beyanı
        </p>
      </Grid>
      <Grid item xs={12}>
        <Paper
          style={{
            height: "350px",
            overflow: "hidden",
            overflowY: "auto",
            padding: "25px",
          }}
        >
          <iframe
            title={props.title}
            src={`data:application/pdf;base64,${props.processContext.kvkkDocument}`}
            height="550"
            width="100%"
          />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <RadioGroup row value={value} onChange={handleChange}>
          <FormControlLabel
            value="1"
            control={<Radio color="primary" />}
            label="Onay Veriyorum"
            classes={{
              label: classes.label,
            }}
          />
          <FormControlLabel
            value="0"
            control={<Radio color="primary" />}
            label="Onay Vermiyorum"
            classes={{
              label: classes.label,
            }}
          />
        </RadioGroup>
      </Grid>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        item
        style={{ marginTop: 30 }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={geriClick}
        >
          Geri
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={devamClick}
        >
          Devam
        </Button>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    processContext: state.processContext,
  };
};

export default connect(mapStateToProps)(Kvkk);
